import { render, staticRenderFns } from "./Accumulator.vue?vue&type=template&id=ec038638&scoped=true&"
import script from "./Accumulator.vue?vue&type=script&lang=js&"
export * from "./Accumulator.vue?vue&type=script&lang=js&"
import style0 from "./Accumulator.vue?vue&type=style&index=0&id=ec038638&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec038638",
  null
  
)

export default component.exports